import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.background?.paper || '#fff',
    border: `1px solid ${palette.divider || '#e0e0e0'}`,
    borderRadius: 8
  },
  header: {
    padding: spacing(2),
    paddingBottom: spacing(1)
  },
  title: {
    marginBottom: spacing(0.5)
  },
  subtitle: {
    fontSize: '0.875rem'
  },
  sectionsList: {
    flex: 1,
    overflowY: 'auto',
    padding: 0
  },
  sectionItem: {
    borderRadius: 4,
    margin: spacing(0.5, 1),
    position: 'relative',
    border: `1px solid ${palette.grey?.[200] || '#f0f0f0'}`,
    '&.Mui-selected': {
      backgroundColor: palette.primary?.light || '#e3f2fd',
      '&:hover': {
        backgroundColor: palette.primary?.light || '#e3f2fd'
      }
    },
    '&:hover $dragIconContainer': {
      opacity: 1
    }
  },
  sectionIcon: {
    minWidth: 36,
    color: palette.text?.secondary || '#666'
  },
  addSection: {
    padding: spacing(2)
  },
  addButton: {
    textTransform: 'none',
    borderStyle: 'dashed'
  },
  menuItem: {
    minWidth: 280,
    padding: spacing(1.5)
  },
  arrowContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: spacing(1),
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing'
    }
  },
  arrowButton: {
    padding: 2,
    minWidth: 24,
    height: 24,
    color: palette.text?.secondary || '#666',
    '&:hover': {
      backgroundColor: palette.action?.hover || 'rgba(0, 0, 0, 0.04)'
    },
    '&.Mui-disabled': {
      color: palette.action?.disabled || 'rgba(0, 0, 0, 0.26)'
    }
  },
  arrowIcon: {
    fontSize: 16,
    lineHeight: 1
  },
  // Root-level style override for drag and drop visual feedback
  // Overrides default ListItem styling during drag operations
  draggedItem: {
    opacity: 0.5,
    transform: 'rotate(2deg) scale(1.02)',
    transition: 'all 0.2s ease',
    zIndex: 1000,
    border: `2px dashed ${palette.primary?.main || '#1976d2'}`,
    borderRadius: 8,
    backgroundColor: palette.primary?.light || '#e3f2fd'
  },
  dragTarget: {
    transform: 'translateY(4px)',
    transition: 'transform 0.2s ease',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
  },
  isDragging: {
    '& $sectionItem': {
      transition: 'transform 0.2s ease'
    }
  },
  dropZone: {
    height: 4,
    margin: spacing(0.5, 1),
    position: 'relative',
    transition: 'all 0.2s ease'
  },
  dropIndicator: {
    height: '100%',
    backgroundColor: palette.primary?.main || '#1976d2',
    borderRadius: 2,
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: -4,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 8,
      height: 8,
      backgroundColor: palette.primary?.main || '#1976d2',
      borderRadius: '50%'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      right: -4,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 8,
      height: 8,
      backgroundColor: palette.primary?.main || '#1976d2',
      borderRadius: '50%'
    }
  },
  dragIconContainer: {
    position: 'absolute',
    bottom: spacing(0.5),
    left: spacing(0.5),
    opacity: 0,
    transition: 'opacity 0.2s ease',
    pointerEvents: 'none',
    zIndex: 10
  },
  dragHoverIcon: {
    fontSize: 14,
    color: palette.text?.secondary || '#666',
    opacity: 0.6
  }
}))
